import axios from '@utils/http'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  updateField({ commit, dispatch, gettings }, field = {}) {
    return axios.put(`/api/cdmFields/${field.id}`, field).then(response => {
      const field = response.data
      return field
    })
  },

  getFields({ commit, dispatch, getters }) {
    return axios.get('/api/cdmFields').then(response => {
      const fields = response.data
      return fields
    })
  },

  updateFieldOrder({ commit, dispatch, gettings }, fields = {}) {
    return axios.put(`/api/cdmFields/updateFieldOrder`, fields)
  },

  updateRevField({ commit, dispatch, gettings }, field = {}) {
    return axios
      .put(`/api/revUsageFields/${field.id}`, field)
      .then(response => {
        const field = response.data
        return field
      })
  },

  updateRevFieldOrder({ commit, dispatch, gettings }, fields = {}) {
    return axios.put(`/api/revUsageFields/updateFieldOrder`, fields)
  },
}
